import {
  ADD_FAVOURITE_PROJECT_COST_PRIORITY,
  ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS,
  FETCH_PROJECT_COST_PRIORITY,
  FETCH_PROJECT_COST_PRIORITY_SUCCESS,
  FETCH_ALL_PROJECT_COST_PRIORITY,
  FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS,
  FILTER_PROJECT_COST_PRIORITY,
  GET_ALL_PROJECT_COST_PRIORITY,
  GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY,
  HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE,
  HIDE_PROJECT_COST_PRIORITY_LOADER,
  SHOW_PROJECT_COST_PRIORITY_LOADER,
  ON_ADD_PROJECT_COST_PRIORITY,
  ON_EDIT_PROJECT_COST_PRIORITY,
  ON_ALL_PROJECT_COST_PRIORITY_SELECT,
  ON_PROJECT_COST_PRIORITY_CLOSE,
  ON_PROJECT_COST_PRIORITY_SELECT,
  ON_DELETE_PROJECT_COST_PRIORITY,
  ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS,
  ON_FILTER_SELECTED_PROJECT_COST_PRIORITY,
  ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT,
  ON_SAVE_PROJECT_COST_PRIORITY,
  ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS,
  ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER,
  SHOW_PROJECT_COST_PRIORITY_MESSAGE,
  UPDATE_SEARCH_PROJECT_COST_PRIORITY,
} from 'constants/ActionTypes';

export const fetchProjectCostPriority = (payload) => {
  return {
      type: FETCH_PROJECT_COST_PRIORITY,
      payload
  };
};
export const fetchProjectCostPrioritySuccess = (payload) => {
  return {
      type: FETCH_PROJECT_COST_PRIORITY_SUCCESS,
      payload
  };
};
export const fetchProjectCostPrioritys = () => {
  return {
      type: FETCH_ALL_PROJECT_COST_PRIORITY
  };
};
export const fetchProjectCostPrioritysSuccess = (payload) => {
  return {
      type: FETCH_ALL_PROJECT_COST_PRIORITY_SUCCESS,
      payload
  };
};
export const showProjectCostPriorityMessage = (message) => {
  return {
      type: SHOW_PROJECT_COST_PRIORITY_MESSAGE,
      payload: message
  };
};
export const addFavouriteProjectCostPriority = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_COST_PRIORITY,
      payload
  };
};
export const addFavouriteProjectCostPrioritySuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_COST_PRIORITY_SUCCESS,
      payload
  };
};
export const onProjectCostPrioritySelect = (payload) => {
  return {
      type: ON_PROJECT_COST_PRIORITY_SELECT,
      payload
  };
};
export const onAddProjectCostPriority = () => {
  return {
      type: ON_ADD_PROJECT_COST_PRIORITY,
  };
};
export const onEditProjectCostPriority = (payload) => {
  return {
      type: ON_EDIT_PROJECT_COST_PRIORITY,
      payload
  };
};
export const onProjectCostPriorityClose = () => {
  return {
      type: ON_PROJECT_COST_PRIORITY_CLOSE,
  };
};
export const onFilterProjectCostPriorityOptionSelect = (payload) => {
  return {
      type: ON_FILTER_PROJECT_COST_PRIORITY_OPTION_SELECT,
      payload
  };
};
export const onSaveProjectCostPriority = (payload) => {
  return {
      type: ON_SAVE_PROJECT_COST_PRIORITY,
      payload
  };
};
export const onSaveProjectCostPrioritySuccess = (data) => {
  return {
      type: ON_SAVE_PROJECT_COST_PRIORITY_SUCCESS,
      payload: data
  };
};
export const onDeleteProjectCostPriority = (payload) => {
  return {
      type: ON_DELETE_PROJECT_COST_PRIORITY,
      payload
  };
};
export const onDeleteProjectCostPrioritySuccess = (payload) => {
  return {
      type: ON_DELETE_PROJECT_COST_PRIORITY_SUCCESS,
      payload
  };
};
export const onFilterSelectedProjectCostPriority = () => {
  return {
      type: ON_FILTER_SELECTED_PROJECT_COST_PRIORITY,
      payload: ''
  };
};
export const filterProjectCostPriority = (payload) => {
  return {
      type: FILTER_PROJECT_COST_PRIORITY,
      payload
  };
};
export const getAllProjectCostPriority = () => {
  return {
      type: GET_ALL_PROJECT_COST_PRIORITY,
      payload: ''
  };
};
export const getUnselectedAllProjectCostPriority = () => {
  return {
      type: GET_UNSELECTED_ALL_PROJECT_COST_PRIORITY,
      payload: ''
  };
};
export const onAllProjectCostPrioritySelect = () => {
  return {
      type: ON_ALL_PROJECT_COST_PRIORITY_SELECT,
      payload: ''
  };
};
export const updateSearchProjectCostPriority = (payload) => {
  return {
      type: UPDATE_SEARCH_PROJECT_COST_PRIORITY,
      payload
  };
};
export const onToggleProjectCostPriorityDrawer = () => {
  return {
      type: ON_TOGGLE_PROJECT_COST_PRIORITY_DRAWER,
  };
};
export const handleProjectCostPriorityRequestClose = () => {
  return {
      type: HANDLE_PROJECT_COST_PRIORITY_REQUEST_CLOSE,
  };
};
export const showProjectCostPriorityLoader = () => {
  return {
      type: SHOW_PROJECT_COST_PRIORITY_LOADER,
  };
};
export const hideProjectCostPriorityLoader = () => {
  return {
      type: HIDE_PROJECT_COST_PRIORITY_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/projectCostPriority.js